import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { TrainingCategoryDto } from "./training-category.dto";
import { CreateTrainingCategoryDto } from "./create-training-category.dto";
import { UpdateTrainingCategoryDto } from "./update-training-category.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class TrainingCategoriesResource extends ResourceBaseService<
  TrainingCategoryDto,
  CreateTrainingCategoryDto,
  UpdateTrainingCategoryDto
> {
  protected EntityDto = TrainingCategoryDto;
  protected CreateEntityDto = CreateTrainingCategoryDto;
  protected UpdateEntityDto = UpdateTrainingCategoryDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/training-categories");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
